import React from 'react';
import DiamondEmpty from '@uber/base-icons/diamond-empty';
import type { AnnotationLabelT } from '../../../../../common/types/types';
import { LABEL_TYPE_CONFIG, TOOL_CONFIG } from '../../../../labelling/components/toolbar/constants';
import { getToolIcon } from '../../../../labelling/components/toolbar/utils';
const isSupportedTool = (tool: string): tool is keyof typeof TOOL_CONFIG | keyof typeof LABEL_TYPE_CONFIG => {
  return tool in TOOL_CONFIG || tool in LABEL_TYPE_CONFIG;
};
export const getAnnotationLabelIcon = (annotationLabel?: AnnotationLabelT, size = 16) => {
  const labelTool = annotationLabel?.tools?.[0];
  const strokeColor = annotationLabel?.style?.strokeColor;
  if (labelTool && isSupportedTool(labelTool)) {
    const Icon = getToolIcon(labelTool);
    return <Icon strokeColor={strokeColor} size={size} />;
  }
  return <DiamondEmpty color={strokeColor} size={size} />;
};